<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="class-select"
			title="分類選択"
			header_height="115"
			v-bind:bottom_height="bottomHeight"
			v-bind:bottom_value="edit_class"
			v-on:close="onClose"
			v-on:click-modal-content="onCloseBottom"
		>
			<template v-slot:header>
				<div class="modal-header-class-select">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClose">取消</v-btn>
				</div>
			</template>
			<template v-if="display">
				<div class="new-add" v-if="$store.getters.isEditable && !isFilterItem">
					<v-btn flat large color="blue" v-on:click="onClickNewClass" v-bind:class="addBtnDisabled" :disabled="!canAddNewClass">
						<v-icon>add</v-icon>
						分類を新規登録する
					</v-btn>
				</div>
				<div class="class-item-group">
					<div 
						class="class-item d-inline-block"
						v-for="c in master_classes"
						v-bind:key="c.code"
						v-bind:data-code="c.code"
						v-bind:class="($store.getters.isEditable && !isFilterItem) ? '' : selectClass(c.code)" 
						v-bind:style="styleClassItem"
					>
						<div 
							class="class-item-name" 
							v-bind:class="($store.getters.isEditable && !isFilterItem) ? selectClass(c.code) : ''" 
							v-on:click="onClickSelect"
						>
							{{ c.name || '&nbsp;' }}
						</div>
						<v-btn fab flat
							class="class-item-btn"
							v-bind:class="selectClass(c.code)"
							v-on:click="onClickEdit"
							:disabled="!hasAdmin"
							v-if="$store.getters.isEditable && !isFilterItem"
						>
							<v-icon>edit</v-icon>
						</v-btn>
					</div>
				</div>
			</template>
			<template v-slot:bottom>
				<div class="edit">
					<v-btn fab flat absolute class="pa-0 ma-0 btn-edit-close"
						v-on:click="onCloseBottom"
					>
						<v-icon>close</v-icon>
					</v-btn>
					<v-text-field
						v-model="master_classes[target_index].name"
						maxlength="15"
						:rules="[rules.required, rules.length, rules.duplicate]"
						label="分類"
						counter
						class="edit-input"
						ref="edit_input"
					></v-text-field>
					<div class="error-text" v-show="error_message">
						{{ error_message }}
					</div>
					<div class="btn-class-delete">
						<v-btn flat class="mt-2"
							v-on:click="onClickClassDelete"
						>
							削除
						</v-btn>
					</div>
				</div>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import clonedeep from 'lodash/cloneDeep';
import { PERMISSION } from '../data/Const';

const uuidv4 = require('uuid/v4');

const findTargetIndex = (classes, code) => {
	if (classes)
		return classes.findIndex(cls => cls.code === code);
	return null;
};

const validateDuplicate = (classes, name) => {
	let duplicate = classes.filter(cls => cls.name === name);
	if (duplicate.length > 1)
		return true;
	else
		return false;
};

const createEmptyClass = () => {
	return {
		code: uuidv4(),
		name: '新しい分類',
		is_updated: 1,
		is_new: 1,
	};
}

const BOTTOM_HEIGHT = 170;

export default {
	name: 'GBRightPaneClassSelect',
	props: [
		"value",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
	},
	data: function() {
		return {
			edit_class: false,
			rules: {
				required: v => !!v || '入力してください',
				length: v => (v || '').length <= 20,
				duplicate: v => !validateDuplicate(this.master_classes, v) || '重複しています',
			},
			target_index: null,
			master_classes: null,
			error_message: '',
		};
	},
	methods: {
		closeBottom: function() {
			this.error_message = '';
			this.edit_class = false;
			this.target_index = null;
		},
		openBottom: function(index) {
			this.error_message = '';
			this.edit_class = true;
			this.target_index = index;
		},
		onClose: function() {
			this.edit_class = false;
			this.target_index = null;
			this.error_message = '';
			this.$emit('close');
		},
		onCloseBottom: function(e) {
			e.stopPropagation();
			if (e.target.closest('.class-item'))
				return ;
			
			if (this.target_index === null)
				return ;
				
			if (!this.confirmError())
				return ;
			this.closeBottom();
		},
		onClickNewClass: function(e) {
			e.stopPropagation();
			this.master_classes.push(createEmptyClass());
			this.openBottom(this.master_classes.length - 1);
			this.focusElement();
		},
		onClickEdit: function(e) {
			if (!this.confirmError())
				return ;
	
			let code = e.target.closest('.class-item').dataset.code;
			e.stopPropagation();
			this.openBottom(findTargetIndex(this.master_classes, code));
			this.focusElement();
		},
		onClickClassDelete: function(e) {
			e.stopPropagation();
			let index = findTargetIndex(this.value.selected, this.master_classes[this.target_index].code);
			if (index !== -1)
				this.value.selected.splice(index, 1);
			this.master_classes.splice(this.target_index, 1);
			this.closeBottom();
		},
		onClickSelect: function(e) {
			if (!this.confirmError())
				return ;
				
			let code = e.target.closest('.class-item').dataset.code;
			e.stopPropagation();
			this.error_message = '';
			this.target_index = findTargetIndex(this.master_classes, code);
			let target_class = this.master_classes[this.target_index];
			let idx = findTargetIndex(this.value.selected, target_class.code);
			if (idx === -1 || idx === null) {
				this.value.selected.push({
					code: target_class.code,
					name: target_class.name,
				});
			}else{
				this.value.selected.splice(idx, 1);
			}
			this.focusElement();
		},
		onClickDone: function() {
			if (!this.confirmError())
				return ;
				
			this.$emit('class-selected', this.value.selected);
			if (this.validateSyncMasterClass()) {
				//DB同期
				this.$store.dispatch('setMasterClasses', this.master_classes).then(() => {
					this.$emit('update-dataset');
				});
			}
			this.onClose();
		},
		validateMasterClass: function() {
			if (!this.edit_class)
				return true;
			if (!this.master_classes[this.target_index].name || validateDuplicate(this.master_classes, this.master_classes[this.target_index].name))
				return false;
			return true;
		},
		confirmError: function() {
			if (!this.validateMasterClass()) {
				if (!this.error_message) {
					this.error_message = 'すでに登録されているか、未入力です'
				}
				return false;
			}
			return true;
		},
		focusElement: function() {
			if (this.edit_class){
				this.$nextTick(() => {
					setTimeout(() => {
						let elem = this.$parent.$parent.$parent.$el.querySelector('.class-select .edit-input input');
						if (this.master_classes[this.target_index].is_new) {
							elem.select();
							this.master_classes[this.target_index].is_new = 0;
						}
					}, 10);
				});
			}
		},
		validateSyncMasterClass: function() {
			let validate = false;
			let copy_master_classes = clonedeep(this.$store.getters.masterClass);
			
			if (this.master_classes.length < copy_master_classes.length)
				validate = true;
				
			this.master_classes.forEach(cls => {
				let index = copy_master_classes.findIndex(c => c.code === cls.code && c.name === cls.name);
				if (index === -1) {
					this.value.selected.map(v => {
						if (v.code === cls.code)
							v.name = cls.name;
						return v;
					});
					cls.is_updated = 1;
					validate = true;
				}
			});
				
			return validate;
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		selectClass: function() {
			return function(code) {
				let array = new Array();
				this.value.selected.forEach(c => {
					if (c.code === code) {
						array.push("class-item-active");
					}
				});
				return array;
			}
		},
		canAddNewClass: function() {
			return this.validateMasterClass() && this.hasAdmin;
		},
		addBtnDisabled: function() {
			if (!this.canAddNewClass)
				return ['disabled', 'add-btn-disabled'];
			return false;
		},
		bottomHeight: function() {
			if (this.edit_class)
				return BOTTOM_HEIGHT;
			return 0;
		},
		hasAdmin: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return false;
			
			return (access_token.pms & PERMISSION.TYPE.ADMIN) > 0;
		},
		styleClassItem: function() {
			let pr = 0;
			if (this.$store.getters.isEditable && !this.isFilterItem) 
				pr = 38;
			return {
				'padding-right': pr + 'px',
			};
		},
		isFilterItem: function() {
			return this.value.is_filter_item;
		},
	},
	watch: {
		value: function(value) {
			if (value === null)
				this.master_classes = null;
			else
				this.master_classes = value.master_classes;
		},
	},
}
</script>
<style>
	.modal-window.class-select .new-add {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}
	.modal-window.class-select .modal-header-class-select {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.class-select .class-item-group {
		margin: 10px;
	}
	.modal-window.class-select .class-item {
		position: relative;
		border: solid 1px #1E90FF;
		border-radius: 20px;
		font-size: 15px;
		height: 40px;
		margin: 5px;
	}
	.modal-window.class-select .class-item-name {
		display: flex;
		align-items: center;
		position: relative;
		top: -1px;
		left: -1px;
		border-radius: 20px 0px 0px 20px;
		height: 40px;
		padding: 0px 10px;
		cursor: pointer;
		user-select: none;
	}
	.modal-window.class-select .class-item-btn {
		position: absolute;
		border-radius: 0px 20px 20px 0px;
		top: -1px;
		right: -1px;
		height: 40px;
		width: 40px;
		margin: 0px;
	}
	.modal-window.class-select .class-item-active {
		background-color: #1E90FF;
		color: white;
	}
	.modal-window.class-select .edit {
		margin: 10px 18px 10px 10px;
	}
	.modal-window.class-select .btn-edit-close {
		top: 0px;
		right: 8px;
		width: 30px;
		height: 30px;
	}
	.modal-window.class-select .edit-input {
		padding: 40px 10px 0px 10px;
		margin: 0px;
	}
	.modal-window.class-select .btn-class-delete {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.class-select .add-btn-disabled {
		color: #DFDFDF !important;
	}
	.modal-window.class-select .error-text {
		display: flex;
		justify-content: center;
		align-items: center;
		color: red;
	}
</style>
